import { useQuery, gql } from '@zenbusiness/application-commons-graphql';

import AccountSettings from './AccountSettings';

export const GET_ACCOUNT_QUERY = gql`
  query AccountQuery {
    accountInfo {
      accountUuid
      accountEmail
      accountPhone
      firstName
      middleName
      lastName
      suffix
      allPartnerOptOut
    }
  }
`;

const Renderer = () => {
  const {
    loading,
    refetch,
    data = {}
  } = useQuery(
    GET_ACCOUNT_QUERY
  );

  const { accountInfo = {} } = data;

  return (
    <AccountSettings loading={loading} account={accountInfo} refresh={refetch} />
  );
};

export default Renderer;
